// Central registry of all image assets keyed by their filename in the brief.
// Missing images render as elegant placeholders until uploaded.
const BASE = "/images";

export const IMAGES = {
  "Tinesh photo.jpg":
    `${BASE}/hgo132tn-hero-portrait.webp`,

  // Home thumbnails
  "01 Campaign Section Image.jpg":
    `${BASE}/gm2a1z2u-card-01-campaigns.webp`,
  "02 Moment Marketing.jpg":
    `${BASE}/jfdvwjgw-cards-02-moment-marketing.webp`,
  "03 Frameworks.jpg":
    `${BASE}/d6rfmjoa-card-03-strategic-content-ips.webp`,
  "04 Television shows and podcasts.jpg":
    `${BASE}/jhe8w9l9-card-04-broadcast-thought-leadership.webp`,
  "05 Making complex financial concepts accessible and engaging.jpg":
    `${BASE}/g4zy1iox-card-05-storytelling.webp`,
  "06 Platform Native.jpg":
    `${BASE}/klw88c42-card-06-platform-native-strategies.webp`,
  "07 Content Strategy.jpg":
    `${BASE}/vp9i5ogf-card-07-audience-segmentation-data-driven-strategy.webp`,

  // Page 02 — Loan Against Mutual Fund (Campaigns)
  "01 Loan Against Mutual Fund - Influencer Campaign thehimanichaudhary.jpg":
    `${BASE}/58z0214s-01-finance-expert-thehimanichaudhary.webp`,
  "02 Loan Against Mutual Fund - Influencer Campaign financewizardcl.jpg":
    `${BASE}/rkeuggha-02-finance-expert-financewizardcl.webp`,
  "03 Loan Against Mutual Fund - Influencer Campaign idea____man.jpg":
    `${BASE}/m8qhhrcf-03-finance-expert-idea-man.webp`,
  "04 Loan Against Mutual Fund - Influencer Campaign ji_nitinjoshi.jpg":
    `${BASE}/frm8yyqu-04-finance-expert-ji-nitinjoshi.webp`,
  "05 Loan Against Mutual Fund - Influencer Campaign escapetolandscapes.jpg":
    `${BASE}/7owwxevh-05-travel-escapetolandscapes.webp`,
  "06 Loan Against Mutual Fund - Influencer Campaign soultravel_vipan.jpg":
    `${BASE}/d89da09d-06-travel-soultravel-vipan.webp`,
  "07 Loan Against Mutual Fund - Influencer Campaign wanderlust_himani.jpg":
    `${BASE}/waaqn2r0-08-travel-wanderlust-himani.webp`,
  "08 Loan Against Mutual Fund - Inorganic campaign 2.jpg":
    `${BASE}/00kfk0yy-08-what-would-you-do-with-1-lakh-today.webp`,
  "09 Loan Against Mutual Fund - Inorganic campaign.jpg":
    `${BASE}/c10oi1n6-09-billionaires-don-t-sell-they-borrow.webp`,

  // Page 03 — Moment Marketing
  "01 Moment Marketing - Connecting Dhurandhar to Finance.jpg":
    `${BASE}/1lrmf96x-01-bollywood-dhurandhar.webp`,
  "02 Moment Marketing - Connecting Halloweeen to Finance.jpg":
    `${BASE}/q5bz53ek-02-halloween.webp`,
  "03 Moment Marketing - Connecting Valentine's Day To Finance.jpg":
    `${BASE}/va9hq7ki-03-valentine-s-day.webp`,
  "04 Moment Marketing - India winning the cricket world cup.jpg":
    `${BASE}/atgwmzq8-04-icc-champions-trophy.webp`,
  "05 Moment marketing - NEERAJ CHOPRA winning gold.jpg":
    `${BASE}/c69ad3j2-05-neeraj-chopra-olympic-gold.webp`,
  "06 Moment Marketing - When UPI was down.jpg":
    `${BASE}/hce90e8c-06-viral-upi-down.webp`,

  // Page 04 — Content Pillars (Content IPs)
  "01 Content Pillar - Changes at top funds.jpg":
    `${BASE}/f8juho3i-01-monthly-fund-overhaul.webp`,
  "02 Content Pillar - Discussing the ecosystems of different sectors.jpg":
    `${BASE}/pws3p4el-02-sector-deep-dive.webp`,
  "03 Content Pillar - Rs 100 invested in funds.jpg":
    `${BASE}/sjmudqy6-03-fund-allocation.webp`,
  "04 Content Pillar - Where mutual funds raised stake.jpg":
    `${BASE}/9had2pee-04-fund-strategy-shifts.webp`,

  // Page 05 — Broadcast & Podcast
  "01 Broadcast and thought leadership 1.jpg":
    `${BASE}/kt8vqen9-01-et-now-episode-balanced-advanateg.webp`,
  "02 Broadcast and thought leadership 2.jpg":
    `${BASE}/1vzphley-02-financial-planning-in-40s.webp`,
  "03 Podcast 1.jpg":
    `${BASE}/ggwl4pl6-03-beyond-returns-dr-m-pattabiraman.webp`,
  "04 Podcast 2.jpg":
    `${BASE}/1ey911z8-04-beyond-returns-ritesh-jain.webp`,

  // Page 06 — Storytelling
  "01 Storytelling - A modest lifestyle is the best way to be financially independent.jpg":
    `${BASE}/yawotcoj-01-the-german-frugal-billionaire.webp`,
  "02 Storytelling How FIRE can backfire.jpg":
    `${BASE}/cvjtmhuf-02-fire-movement.webp`,
  "03 Storytelling - Using Fund Managers Instead of Funds.jpg":
    `${BASE}/dwe4q7xo-03-two-fund-managers-one-philosophy.webp`,

  // Page 08 — Audience Segmentation
  "ET Money Learn.jpg":
    `${BASE}/c5p5xt1n-01-the-learn-hub.webp`,
  "Author Page.jpg":
    `${BASE}/rr9wso38-02-complete-author-archive.webp`,

  // Page 07 — Platform Native (Twitter)
  "01 Twitter.jpg":
    `${BASE}/ultlg6no-01-the-ranking-collapse.webp`,
  "02 Twitter.jpg":
    `${BASE}/sph5zpy2-02-two-legends-one-philosophy.webp`,
};

export const getImage = (filename) => IMAGES[filename] || null;
